import { Components } from '@mui/material/styles/components';
import { ControllerFont } from '../../fonts';
import theme from '../../provider/controllerBaseTheme';

export const InputBaseComponent: Components = {
  MuiInputBase: {
    styleOverrides: {
      root: {
        borderRadius: 2,
        color: theme.palette.text.primary,
        padding: 0,
        '& input, & textarea': {
          ...ControllerFont.Body400R,
          height: 'auto',
          padding: theme.spacing(1.25, 1),
        },
        //
        // mason classes
        //
        '& .MasonOutlinedInputErrorIcon': {
          color: theme.palette.error.main,
          fontSize: theme.spacing(2),
          height: theme.spacing(2),
          lineHeight: theme.spacing(2),
        },
      },
      sizeSmall: {
        '& input, & textarea': {
          padding: theme.spacing(1),
        },
      },
    },
  },
};
